import { useEffect, useRef, useState, type ChangeEvent, type KeyboardEvent } from 'react';
import io from 'socket.io-client';
import { api } from '@/utils/api';
import { GetStorage } from '@/shared/services/credentialsService';
import Inputfield from '@/shared/inputfield';
import CustomButton from '@/shared/button/customButton';
import ContentContainer from '@/components/containers/contentContainer';
import { SearchCircleBlackIcon, SendIcon } from '@/components/assets/icons/svgs';
import axios from 'axios';
import LazyImage from '@/shared/lazyImage';
import { calculateMessageTime } from '@/shared/services/credentialsService/const';
import Popup from '@/shared/popups/popupDetails';
import SendProposal from '@/pages/hire/send-proposal';
import Resizer from "react-image-file-resizer";
import { toast } from "@/utils/appToast";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ChatContainer from '@/components/containers/chatContainer';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import { updateUser } from '@/features/user/userSlice';
import { trackUserAction } from '@/utils/analytics';
import { trackMetaContact } from '@/utils/metaPixel';
import NewProposalForm from '@/pages/hire/new-proposal-form';
import { workerPath } from '@/shared/publicPaths';
import { encodeId } from '@/utils/idEncoder';

const baseURL = import.meta.env.VITE_BACKEND_URL;

const slugifyName = (first?: string, last?: string) => {
  const fullName = `${first || ''} ${last || ''}`.trim();
  return fullName
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '');
};

const resolveWorkerProfileId = (chatUser?: {
  workerProfile?: string | { _id?: string };
  workerProfileId?: string;
} | null) => {
  if (!chatUser) return null;
  if (typeof chatUser.workerProfile === 'string' && chatUser.workerProfile.trim()) {
    return chatUser.workerProfile.trim();
  }
  if (chatUser.workerProfile?._id) return String(chatUser.workerProfile._id);
  if (chatUser.workerProfileId) return String(chatUser.workerProfileId);
  return null;
};

const buildWorkerProfilePath = (
  chatUser?: {
    fullName?: string;
    first_name?: string;
    last_name?: string;
    workerProfile?: string | { _id?: string };
    workerProfileId?: string;
  } | null
) => {
  const workerProfileId = resolveWorkerProfileId(chatUser);
  if (!workerProfileId) return null;

  const nameParts = chatUser?.fullName?.trim().split(/\s+/) || [];
  const firstName = chatUser?.first_name || nameParts[0];
  const lastName = chatUser?.last_name || nameParts.slice(1).join(' ');
  const slug = `${slugifyName(firstName, lastName)}-${encodeId(workerProfileId)}`;
  return workerPath(slug);
};

const ChatUI = () => {
  const [proposalPopupShow, setProposalPopupToggle] = useState(false);
  const [chatList, setChatList] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [search, setSearch] = useState('');
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [imagePreviews, setImagePreviews] = useState<string[]>([]);
  const [isUploadingImages, setIsUploadingImages] = useState(false);
  const { user } = useSelector((state: { user }) => state.user);
  const navigate = useNavigate();
  const { chatId: chatIdFromUrl } = useParams<{ chatId?: string }>();
  const userId = GetStorage()?.data?.user?._id;
  const messagesEndRef = useRef(null);
  const [workerId, setWorkerId] = useState(null);
  const [workerProfileId, setWorkerProfileId] = useState(null);
  const [otherUser, setOtherUser] = useState(null);
  const [isLoadingOtherUser, setIsLoadingOtherUser] = useState(false);
  const [isLoadingChatList, setIsLoadingChatList] = useState(true);
  const [clientsId, setClientId] = useState('')
const [proposalId,setProposalId] = useState('')
const [proposalPopupMode, setProposalPopupMode] = useState<'direct' | 'request_quote'>('direct')
const socketRef = useRef(null);
const [isSocketConnected, setIsSocketConnected] = useState(false);
const selectedChatRef = useRef(null); // Store selected chat to rejoin on reconnect
const fileInputRef = useRef<HTMLInputElement>(null);
const messageInputRef = useRef<HTMLTextAreaElement>(null);
const mainScrollRef = useRef<HTMLDivElement>(null);
const messagesScrollRef = useRef<HTMLDivElement>(null);
const MESSAGE_INPUT_MAX_HEIGHT = 128; // ~4-5 lines (max-h-32)
const lastScrollTopRef = useRef(0);
const [isHeaderHidden, setIsHeaderHidden] = useState(false);
const [previewImage, setPreviewImage] = useState<string | null>(null);
const hasOpenedMobileChatListRef = useRef(false);
  const dispatch = useDispatch();
const { clientId, providerId, providerProfileId, returnTo } = useLocation()?.state || {};
console.log("clientssssId",clientId, providerId, providerProfileId)
const { t } = useTranslation();
// Helper function to check if a message is an image message
const isImageMessage = (message: string): boolean => {
  try {
    const parsed = JSON.parse(message);
    return Array.isArray(parsed) && parsed.every(url => typeof url === 'string' && url.includes('http'));
  } catch (e) {
    return false;
  }
};

const extractJobUid = (message: string): string | null => {
  const match = message.match(/Job ID:\s*(JOB-[a-zA-Z0-9]+)/);
  const val =  match ? match[1] : null;
  console.log('got response match',val)
  return val
};


const handleQuoteAction = (selectedChat , jobid: string) => {
    setProposalPopupMode('request_quote');
    setProposalId(jobid)
    handleProposalPopup(selectedChat)
    //setProposalPopupToggle(true)
}

// Helper function to get display text for last message
const getLastMessageText = (lastMsg?: { message?: string; imageUrls?: string[] } | null): string => {
  if (!lastMsg?.message && !lastMsg?.imageUrls?.length) return t('noMessagesYet');

  const message = lastMsg.message || '';
  const photoCount = lastMsg.imageUrls?.length || 0;

  if (!message.trim() && photoCount > 0) return t('upload_or_drag_image');
  if (isImageMessage(message) && photoCount === 0) return t('upload_or_drag_image');

  if (message.includes('New Quote Request')) {
    const headline = message.split('\n')[0].replace(/\*\*/g, '').trim();
    if (photoCount > 0) {
      return `${headline} · ${photoCount} ${photoCount === 1 ? 'photo' : 'photos'}`;
    }
    return headline || message;
  }

  return message;
};



  useEffect(() => {
    const resetUnseen = async () => {
      const response = await api.resetUnseenMessages();
      if (response.success) {
        console.log("messagcounterdata",response.data)
        dispatch(updateUser({ ...user, unSeenMessageCounter: 0 }));

      }
    };

    resetUnseen();
  }, []);
  


useEffect(() => {
 
  if (!user?.userChaTId || user?.userChatCounter === undefined) return;

  setChatList(prev =>
    prev.map(chat => {
      if (chat._id === user.userChaTId) {
        const updatedCounters = chat.unSeenMessageCounter?.map(counter => {
          if (counter.user === userId) {
            return { ...counter, count: user.userChatCounter };
          }
          return counter;
        });
        return { ...chat, unSeenMessageCounter: updatedCounters };
      }
      return chat;
    })
  );
}, [user?.userChaTId, user?.userChatCounter]);


  const handleSelectChat = async (chat) => {
   
  setSelectedChat(chat);

  // Reset backend counter for this chat
 await api.resetChatUnseenMessages(chat._id);

  // Reset local counter
    setChatList(prev =>
    prev.map(c => {
      if (c._id === chat._id) {
        const updatedCounters = c.unSeenMessageCounter?.map(counter => {
          if (counter.user === userId) {
            return { ...counter, count: 0 };
          }
          return counter;
        });
        return { ...c, unSeenMessageCounter: updatedCounters };
      }
      return c;
    })
  );
};


// Function to fetch other user details
const fetchOtherUserDetails = async (otherUserId: string) => {

  setIsLoadingOtherUser(true);
  try {
    let userDetails;
    
    // Determine if we need to fetch worker or client based on current user type
    if (user?.type === 'user') {
      // Current user is client, fetch worker details
      const response = await api.getWorkerById(otherUserId);
      if (response && response?.user?._id) {
        userDetails = {
          _id: response.user?._id || otherUserId,
          fullName: response.user?.fullName || `${response.user?.first_name || ''} ${response.user?.last_name || ''}`.trim(),
          avatar: response.user?.avatar,
          type: 'worker',
          workerProfileId: response._id || response.id || otherUserId,
          first_name: response.user?.first_name,
          last_name: response.user?.last_name,
        };
          setOtherUser(userDetails);
        
      }
    } else if (user?.type === 'worker') {
      // Current user is worker, fetch client details
      const response = await api.getUserById(otherUserId);
    
      if (response && response?._id) {
        userDetails = {
          _id: response._id || otherUserId,
          fullName: response.fullName || response.first_name + ' ' + response.last_name,
          avatar: response.avatar,
          type: 'user'
        };
       
        setOtherUser(userDetails);

      }
      
    }
    
  
  } catch (error) {
    toast.error('No se pudieron cargar los detalles del usuario');
  } finally {
    setIsLoadingOtherUser(false);
  }
};

  const closeForm = () =>{
    setProposalId('')
    setProposalPopupToggle(false)
   }

// Initialize socket with iPhone-friendly configuration
useEffect(() => {
  if (!userId) return;

  // Create socket with iPhone/Safari-friendly options
  const socket = io(baseURL, {
    withCredentials: true,
    // iPhone Safari requires polling fallback
    transports: ['websocket', 'polling'],
    // Enable reconnection for iPhone background/foreground handling
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: Infinity,
    // Timeout settings for mobile networks
    timeout: 20000,
    // Force new connection to avoid stale connections
    forceNew: false,
    // Upgrade transport automatically
    upgrade: true,
    // Remember transport preference
    rememberUpgrade: true,
  });

  socketRef.current = socket;

  // Connection event handlers
  socket.on('connect', () => {
    console.log('✅ Socket connected:', socket.id);
    setIsSocketConnected(true);
    
    // Register user immediately after connection
    if (userId) {
      socket.emit("registerUser", userId);
      
      // Re-join the selected room after a small delay to ensure registration is processed
      if (selectedChatRef.current?._id) {
        setTimeout(() => {
          socket.emit('joinRoom', selectedChatRef.current._id);
          console.log('🔄 Re-joined room after connection:', selectedChatRef.current._id);
        }, 100);
      }
    }
  });

  socket.on('disconnect', (reason) => {
    console.log('❌ Socket disconnected:', reason);
    setIsSocketConnected(false);
    
    // Reconnect on certain disconnect reasons (important for iPhone)
    if (reason === 'io server disconnect') {
      // Server disconnected, reconnect manually
      socket.connect();
    }
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error);
    setIsSocketConnected(false);
  });

  socket.on('reconnect', (attemptNumber) => {
    console.log('✅ Socket reconnected after', attemptNumber, 'attempts');
    setIsSocketConnected(true);
    
    // Re-register user after reconnection
    if (userId) {
      socket.emit("registerUser", userId);
      
      // Re-join the selected room after a small delay to ensure registration is processed
      if (selectedChatRef.current?._id) {
        setTimeout(() => {
          socket.emit('joinRoom', selectedChatRef.current._id);
          console.log('🔄 Re-joined room after reconnection:', selectedChatRef.current._id);
        }, 100);
      }
    }
  });

  socket.on('reconnect_attempt', (attemptNumber) => {
    console.log('🔄 Reconnection attempt', attemptNumber);
  });

  socket.on('reconnect_error', (error) => {
    console.error('Reconnection error:', error);
  });

  socket.on('reconnect_failed', () => {
    console.error('❌ Reconnection failed');
    setIsSocketConnected(false);
  });

  // Handle iPhone page visibility changes (app backgrounding/foregrounding)
  const handleVisibilityChange = () => {
    if (document.hidden) {
      // App went to background - socket.io will handle this
      console.log('📱 App went to background');
    } else {
      // App came to foreground - ensure connection
      console.log('📱 App came to foreground');
      if (!socket.connected) {
        socket.connect();
      }
    }
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  // Cleanup
  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    if (socket) {
      socket.removeAllListeners();
      socket.disconnect();
      socketRef.current = null;
    }
  };
}, [userId]);

  // Listen for incoming messages
  useEffect(() => {
    const socket = socketRef.current;
    if (!socket || !isSocketConnected) return;

    const handleReceiveMessage = (msg) => {
      const normalized = {
        ...msg,
        owner: msg.owner ?? msg.sender,
      };

      if (normalized.chatId === selectedChat?._id) {
        setMessages(prev => [...prev, normalized]);
      } else {
        // Increment counter for other chats
        setChatList(prev => prev.map(chat => 
          chat._id === normalized.chatId 
            ? { ...chat, unseenCount: (chat.unseenCount || 0) + 1 } 
            : chat
        ));
      }
      
      // Update the chat list to reflect the new last message and re-sort by updatedAt
      setChatList(prev => {
        const updatedChats = prev.map(chat => {
          if (chat._id === normalized.chatId) {
            return {
              ...chat,
              history: [...(chat.history || []), normalized],
              updatedAt: new Date().toISOString() // Update the timestamp
            };
          }
          return chat;
        });
        
        // Sort by updatedAt in descending order (most recent first)
        return updatedChats.sort((a, b) => {
          const dateA = new Date(a.updatedAt || a.createdAt || 0);
          const dateB = new Date(b.updatedAt || b.createdAt || 0);
          return dateB.getTime() - dateA.getTime();
        });
      });
    };

    socket.on("receiveMessage", handleReceiveMessage);

    return () => {
      socket.off("receiveMessage", handleReceiveMessage);
    };
  }, [selectedChat, isSocketConnected]);


  useEffect(() => {
    const fetchChats = async () => {
      setIsLoadingChatList(true);
      try {
        const chats = await api.getAllUserChats();
        // Sort chats by updatedAt in descending order (most recent first)
       const sortedChats = chats.map(chat => {
      const unseenForCurrentUser = chat.unSeenMessageCounter?.find(u => u.user === user._id)?.count || 0;
      return { ...chat, unseenCount: unseenForCurrentUser };
    }).sort((a, b) => new Date(b.updatedAt || b.createdAt).getTime() - new Date(a.updatedAt || a.createdAt).getTime());

        setChatList(sortedChats);

        // Deep link: /chat/:chatId (email / push notification)
        if (chatIdFromUrl) {
          const chatFound = sortedChats.find((chat) => chat._id === chatIdFromUrl);
          if (chatFound) {
            await handleSelectChat(chatFound);
          } else {
            const fetched = await api.getChatById(chatIdFromUrl);
            const chat = fetched?._id ? fetched : fetched?.data;
            if (chat?._id) {
              setChatList((prev) =>
                prev.some((c) => c._id === chat._id) ? prev : [chat, ...prev]
              );
              await handleSelectChat(chat);
            }
          }
        } else if (sortedChats.length > 0) {
          if(clientId && providerId){
            console.log("sortedChats",sortedChats, clientId, providerId, providerProfileId)

            const chatFound = sortedChats.find((chat) => 
              chat.users.some(user => user._id === clientId) && 
              chat.users.some(user => user._id === providerId)
            );
            if (chatFound) {
              console.log("chatFound",chatFound)
              handleSelectChat(chatFound);
            } else {
              console.log("clientId",clientId, providerId)
              // No existing chat found, fetch other user details
              const otherUserId = user?.type === 'user' ? providerProfileId : clientId;
              console.log("otherUserId",otherUserId)
              if (otherUserId) {
                await fetchOtherUserDetails(otherUserId);
              }
            }
          } 
        }
        else {
            // No existing chat found, fetch other user details
            const otherUserId = user?.type === 'user' ? providerProfileId : clientId;
            console.log("otherUserId",otherUserId)
            if (otherUserId) {
              await fetchOtherUserDetails(otherUserId);
            }
        }
      } catch (error) {
        console.error("Error fetching chats:", error);
      } finally {
        setIsLoadingChatList(false);
      }
    };
    fetchChats();
  }, [clientId, providerId, chatIdFromUrl]);

  useEffect(() => {
    const el = mainScrollRef.current;
    if (!el) return;
    // Keep header always visible when a specific chat is open
    if (selectedChat) {
      setIsHeaderHidden(false);
      return;
    }
    lastScrollTopRef.current = el.scrollTop || 0;
    const onScroll = () => {
      const current = el.scrollTop;
      const delta = 8;
      if (typeof window !== 'undefined' && window.innerWidth >= 1024) {
        setIsHeaderHidden(false);
        lastScrollTopRef.current = current;
        return;
      }
      if (current > lastScrollTopRef.current + delta) {
        setIsHeaderHidden(true);
        lastScrollTopRef.current = current;
      } else if (current < lastScrollTopRef.current - delta) {
        setIsHeaderHidden(false);
        lastScrollTopRef.current = current;
      }
    };
    el.addEventListener('scroll', onScroll);
    return () => {
      el.removeEventListener('scroll', onScroll);
    };
  }, [selectedChat]);

  // (removed) mobile floating header reveal logic

  useEffect(() => {
    if (
      !hasOpenedMobileChatListRef.current &&
      typeof window !== 'undefined' &&
      window.innerWidth < 1024 &&
      !selectedChat &&
      chatList.length > 0
    ) {
      setShowMobileChatList(true);
      hasOpenedMobileChatListRef.current = true;
    }
  }, [chatList, selectedChat]);

  useEffect(() => {
    if (!selectedChat?._id) {
      selectedChatRef.current = null;
      return;
    }
    
    // Update ref to track selected chat for reconnection
    selectedChatRef.current = selectedChat;
    
    const socket = socketRef.current;
    if (!socket || !isSocketConnected) {
      console.warn('Socket not connected, cannot join room');
      // Still fetch messages even if socket is not connected
      const fetchMessages = async () => {
        const chat = await api.getChatById(selectedChat._id);
        setMessages(chat?.history || []);
      };
      fetchMessages();
      return;
    }

    // Register user first (in case it wasn't registered yet), then join room
    if (userId) {
      socket.emit("registerUser", userId);
    }
    
    // Join room after a small delay to ensure registration is processed on backend
    setTimeout(() => {
      socket.emit('joinRoom', selectedChat._id);
      console.log('✅ Joined room:', selectedChat._id);
    }, 50);
    
    const fetchMessages = async () => {
      const chat = await api.getChatById(selectedChat._id);
      setMessages(chat?.history || []);
    };
    fetchMessages();
  }, [selectedChat, isSocketConnected, userId]);

  // Image upload functions
  const resizeImage = async (file: File) => {
    return new Promise<Blob>((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        'JPEG',
        90,
        0,
        (uri: any) => {
          resolve(uri);
        },
        'blob'
      );
    });
  };

  const uploadImages = async (): Promise<string[]> => {
    if (selectedImages.length === 0) return [];

    const uploadedUrls: string[] = [];

    for (const image of selectedImages) {
      const resizedImage = await resizeImage(image);
      const formData = new FormData();
      formData.append('file', resizedImage);

      const response = await api.updateJobPhoto(formData);

      if (response && response.success) {
        uploadedUrls.push(response.data || response);
      } else {
        throw new Error(`Failed to upload image: ${response?.message || 'Unknown error'}`);
      }
    }

    return uploadedUrls;
  };

  const handleImageChange = (files: File[]) => {
  const totalImages = selectedImages.length + files.length;
  if (totalImages > 5) {
    toast.error('Solo puedes seleccionar hasta 5 imágenes.');
    return;
  }

  const newValidFiles: File[] = [];
  const newPreviewUrls: string[] = [];

  for (const file of files) {
    if (file.size > 10 * 1024 * 1024) {
      toast.error(`La imagen "${file.name}" supera los 10MB y fue omitida.`);
      continue;
    }

    newValidFiles.push(file);
    newPreviewUrls.push(URL.createObjectURL(file));
  }

  setSelectedImages(prev => [...prev, ...newValidFiles]);
  setImagePreviews(prev => [...prev, ...newPreviewUrls]);
};


  const handleImageButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      handleImageChange(Array.from(files));
    }
    // Reset the input value so the same file can be selected again
    e.target.value = '';
  };

  const handleRemoveImage = (index: number) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviews(prev => prev.filter((_, i) => i !== index));
  };

  const resizeMessageInput = (el?: HTMLTextAreaElement | null) => {
    const textarea = el ?? messageInputRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${Math.min(textarea.scrollHeight, MESSAGE_INPUT_MAX_HEIGHT)}px`;
  };

  const handleMessageInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setInput(e.target.value);
    resizeMessageInput(e.target);
  };

  const handleMessageInputKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const sendMessage = async () => {
    console.log("selectedChat",selectedChat, otherUser)
    if ((!input.trim() && selectedImages.length === 0) || (!selectedChat?._id && !otherUser?._id)) return;

    const currentUserId = user?._id

    // Upload images if any
    let imageUrls: string[] = [];
    if (selectedImages.length > 0) {
      setIsUploadingImages(true);
      try {
        imageUrls = await uploadImages();
      } catch (error: any) {
        console.error("Error uploading images:", error);
        toast.error(
          error?.message ||
            t("something_went_wrong") ||
            "No se pudieron subir las imágenes. Inténtalo de nuevo."
        );
        setIsUploadingImages(false);
        return;
      }
      setIsUploadingImages(false);
    }

    const messageText = input.trim() || (imageUrls.length > 0 ? t('upload_or_drag_image') : '');

    console.log("selectedChat",selectedChat, otherUser)
    // Emit via socket for real-time update
    const socket = socketRef.current;
    if (selectedChat?._id && socket && isSocketConnected) {
      // Existing chat
      socket.emit("sendMessage", {
        chatId: selectedChat._id,
        message: messageText,
        imageUrls,
        sender: currentUserId,
      });
      
      // Track message sent via socket
      trackUserAction('message_sent', {
        chat_id: selectedChat._id,
        recipient_id: otherUser?._id || '',
        has_images: imageUrls.length > 0,
        user_type: user?.type || 'unknown',
        message_type: 'socket'
      });
      trackMetaContact({
        content_name: 'chat_message',
        content_ids: selectedChat._id,
      });
    } else if (otherUser?._id) {
      if(user?.type === 'user'){
        api.sendMessageToWorker(
          otherUser?._id,
          messageText,
          undefined,
          imageUrls.length > 0 ? imageUrls : undefined
        ).then((res) => {
          // Track message sent
          trackUserAction('message_sent', {
            recipient_id: otherUser?._id,
            recipient_type: 'worker',
            has_images: imageUrls.length > 0,
            user_type: 'client',
            message_type: 'api'
          });
          trackMetaContact({
            content_name: 'chat_message',
            content_ids: otherUser?._id,
          });
          
          api.getAllUserChats().then((res) => {
            if(res && res.length > 0){
              // Sort chats by updatedAt in descending order (most recent first)
              const sortedChats = res.sort((a, b) => {
                const dateA = new Date(a.updatedAt || a.createdAt || 0);
                const dateB = new Date(b.updatedAt || b.createdAt || 0);
                return dateB.getTime() - dateA.getTime();
              });
              setChatList(sortedChats);
              const userChat = sortedChats.filter((chat) => chat.users.some((user) => user._id === otherUser?._id));
              if(userChat.length > 0){
                handleSelectChat(userChat[0]);
              }else{
                setSelectedChat(null);
              }
            }
          });
         
         
        }).catch((err) => {
        })
      } else if(user?.type === 'worker'){
        api.sendMessageToClient(
          otherUser?._id,
          messageText,
          imageUrls.length > 0 ? imageUrls : undefined
        ).then((res) => {
          // Track message sent
          trackUserAction('message_sent', {
            recipient_id: otherUser?._id,
            recipient_type: 'client',
            has_images: imageUrls.length > 0,
            user_type: 'worker',
            message_type: 'api'
          });
          trackMetaContact({
            content_name: 'chat_message',
            content_ids: otherUser?._id,
          });
          
          api.getAllUserChats().then((res) => {
            if(res && res.length > 0){
              // Sort chats by updatedAt in descending order (most recent first)
              const sortedChats = res.sort((a, b) => {
                const dateA = new Date(a.updatedAt || a.createdAt || 0);
                const dateB = new Date(b.updatedAt || b.createdAt || 0);
                return dateB.getTime() - dateA.getTime();
              });
              setChatList(sortedChats);
              const userChat = sortedChats.filter((chat) => chat.users.some((user) => user._id === otherUser?._id));
              if(userChat.length > 0){
                handleSelectChat(userChat[0]);
              }else{
                setSelectedChat(null);
              }
            }
          });
        });
      }
      // console.log("otherUser",otherUser)
      // // New conversation - create chat via socket
      // socket.emit("sendMessage", {
      //   participants: [currentUserId, otherUser?._id],
      //   message: imageUrls.length > 0 ? JSON.stringify(imageUrls) : input,
      //   sender: currentUserId,
      // });
    }

    setInput("");
    setSelectedImages([]);
    setImagePreviews([]);
    if (messageInputRef.current) {
      messageInputRef.current.style.height = 'auto';
    }
  };


  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);


  const handleProposalPopup = (chat) => {
    const otherUser = chat.users?.find((u) => u._id === userId);
     const clientUser = chat.users?.find((u) => u._id !== userId);
   setClientId(clientUser?._id)
    console.log("otherUser",otherUser)
    setWorkerId(otherUser?._id);
    setWorkerProfileId(otherUser?.workerProfile);
    setProposalPopupToggle(true);
    setSelectedChat(chat);
  }

  const handleChatNavigation = () => {
    const userType = user?.type;
    console.log("selectedChat",selectedChat)
    return;
    if(userType === 'client'){
      navigate('/transactions-history', { state: { chatId: selectedChat?._id } });
    }else{
      navigate('/payments-history', { state: { chatId: selectedChat?._id } });
    }
  }

  const handleOpenProviderProfile = (chatUser) => {
    if (user?.type !== 'user') return;
    const profilePath = buildWorkerProfilePath(enrichChatUserForProfile(chatUser));
    if (profilePath) navigate(profilePath);
  };

  const enrichChatUserForProfile = (chatUser) => {
    if (!chatUser) return chatUser;
    if (resolveWorkerProfileId(chatUser)) return chatUser;
    if (
      providerProfileId &&
      providerId &&
      String(chatUser._id) === String(providerId)
    ) {
      return { ...chatUser, workerProfileId: providerProfileId };
    }
    return chatUser;
  };

  const canOpenProviderProfile = (chatUser) =>
    user?.type === 'user' &&
    Boolean(buildWorkerProfilePath(enrichChatUserForProfile(chatUser)));

  const [showMobileChatList, setShowMobileChatList] = useState(false);

  const handleMobileChatBack = () => {
    if (returnTo) {
      navigate(returnTo);
      return;
    }
    setShowMobileChatList(true);
  };

  return (
    <ChatContainer className="bg-[#F7F9FB] !px-0 !py-0 overflow-y-hidden">
       <Popup
        slotProps={{ preventOutsideClose: true }}
        size={'sm'}
        className="bg-darkBlue"
        headerTitle=""
        isOpen={proposalPopupShow}
        handleSubmit={()=>{}}
        handleClose={() => setProposalPopupToggle(false)}

        bodyChildren={
          proposalPopupMode === 'request_quote' ? (
            <NewProposalForm
              requestQuoteJobId={proposalId}
              onSuccess={() => closeForm()}
              onClose={() => closeForm()}
            />
          ) : (
            <SendProposal
              workerid={workerId}
              workerProfileId={workerProfileId}
              jobId={proposalId}
              jobUserID={clientsId}
              jobtype="worker"
              onSuccess={() => closeForm()}
            />
          )
        }
      />

      {previewImage && (
        <Popup
          isOpen={!!previewImage}
          handleClose={() => setPreviewImage(null)}
          size="lg"
          className="bg-black bg-opacity-80 flex items-center justify-center"
          isShowCloseIcon
          isShowBlackCrossIcon
          bodyChildren={
            <div className="flex justify-center items-center w-full h-full">
              <img
                src={previewImage}
                alt="Preview"
                className="max-h-[90vh] max-w-full object-contain rounded-lg shadow-lg"
              />
            </div>
          }
        />
      )}
      
      {/* Mobile Chat List Overlay */}
      <div className={`lg:hidden fixed inset-0 z-50 transition-transform duration-300 ${showMobileChatList ? 'translate-x-0' : '-translate-x-full'}`}>
        {/* Backdrop */}
        <div 
          className="absolute inset-0 "
          onClick={() => setShowMobileChatList(false)}
        />
        
        {/* Chat List Sidebar */}
        <div className="absolute left-0 top-0 h-full w-80 max-w-[85vw] bg-white shadow-xl">
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h2 className="text-xl font-bold">{t('chats')}</h2>
            <button 
              onClick={() => setShowMobileChatList(false)}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              ✕
            </button>
          </div>
          
          <div className="p-4">
            <Inputfield
              name="search"
              variant="solid"
              leftIcon={<SearchCircleBlackIcon className="absolute left-2 top-3" />}
              placeholder={t('search')}
              className="w-full py-2 focus:outline-none text-sm"
              inputClassName="!bg-[#F5F9FE] !outline-none rounded-[24px]"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          
          <div className="flex-1 overflow-y-auto">



            {chatList
              .filter((chat) => {
                const otherUser = chat.users?.find((u) => u._id !== userId);
                return otherUser?.fullName?.toLowerCase().includes(search.toLowerCase());
              })
              .map((chat) => {
                const otherUser = chat.users?.find((u) => u._id !== userId);
                const userCounter = chat.unSeenMessageCounter?.find(c => c.user === userId);
                const counter = userCounter?.count || 0;
                return (
                  <div
                    key={chat._id}
                    className={`flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-gray-100 ${
                      selectedChat?._id === chat._id ? 'bg-gray-100' : ''
                    }`}
                    onClick={() => {
                      handleSelectChat(chat);
                      setShowMobileChatList(false);
                    }}
                  >
                   <div className="relative">
                <LazyImage
                  src={otherUser?.avatar || '/images/resource/user-placeholder.png'}
                  alt={otherUser?.fullName}
                  className="w-12 h-12 rounded-full object-cover"
                />
                {counter > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                    {counter}
                  </span>
                )}
              </div>

                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between items-center">
                        <span className="font-semibold text-base truncate min-w-0">{otherUser?.fullName || t('worker')}</span>
                        <span className="text-xs text-gray-400 ml-2 text-right flex-shrink-0">{calculateMessageTime(chat.history?.at(-1)?.date, t)}</span>
                      </div>
                      <span className="text-xs text-gray-500 truncate block max-w-[180px]">
                        {getLastMessageText(chat.history?.at(-1))}
                      </span>
                       
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      <div className="flex h-[100svh] lg:h-[90vh] overflow-hidden">
        {/* Desktop Sidebar - Hidden on mobile */}
        <div className="hidden lg:flex w-[320px] min-w-[260px] max-w-[340px] bg-white border-r border-gray-200 flex-col h-full">
          <div className="sticky top-0 z-10 bg-white">
            <div className="p-4 pb-2 border-b border-gray-100">
              <h2 className="text-xl font-bold">{t('chats')}</h2>
            </div>
            <div className="mx-4 py-2 relative">
              <Inputfield
                name="search"
                variant="solid"
                leftIcon={<SearchCircleBlackIcon className="absolute left-2 top-3" />}
                placeholder={t('search')}
                className="w-full py-2 focus:outline-none text-sm"
                inputClassName="!bg-[#F5F9FE] !outline-none rounded-[24px]"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="flex-1 overflow-y-auto min-h-0">
            {chatList
              .filter((chat) => {
                const otherUser = chat.users?.find((u) => u._id !== userId);
                return otherUser?.fullName?.toLowerCase().includes(search.toLowerCase());
              })
              .map((chat) => {
                const otherUser = chat.users?.find((u) => u._id !== userId);
               const userCounter = chat.unSeenMessageCounter?.find(c => c.user === userId);
                const counter = userCounter?.count || 0;
                return (
                  <div
                    key={chat._id}
                    className={`flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-gray-100 ${
                      selectedChat?._id === chat._id ? 'bg-gray-100' : ''
                    }`}
                    onClick={() => handleSelectChat(chat)}
                  >
                   <div className="relative">
                      <LazyImage
                        src={otherUser?.avatar || '/images/resource/user-placeholder.png'}
                        alt={otherUser?.fullName}
                        className="w-12 h-12 rounded-full object-cover"
                      />
                      {counter > 0 && (
                        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                          {counter}
                        </span>
                      )}
                    </div>

                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between items-center">
                        <span className="font-semibold text-base truncate min-w-0">{otherUser?.fullName || t('worker')}</span>
                        <span className="text-xs text-gray-400 ml-2 text-right flex-shrink-0">{calculateMessageTime(chat.history?.at(-1)?.date, t)}</span>
                      </div>
                      <span className="text-xs text-gray-500 truncate block max-w-[180px]">
                        {getLastMessageText(chat.history?.at(-1))}
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        {/* Main Chat Area */}
      <div ref={mainScrollRef} className="flex-1 flex flex-col h-full overflow-x-hidden min-h-0">

          {/* floating header removed; using single sticky header below */}
          {selectedChat ? (
            <>
              {/* Header */}
              <div className="sticky top-0 z-20  border-b border-gray-200 flex-shrink-0 bg-white" style={{ WebkitTransform: 'translateZ(0)', willChange: 'transform' }}>
                <div className="flex items-center justify-between px-4 lg:px-8 h-14 lg:h-16">
                  <div className="flex items-center gap-3 min-w-0">
                    <button
                      className="lg:hidden p-2 hover:bg-gray-100 rounded-full shrink-0"
                      onClick={handleMobileChatBack}
                      aria-label={returnTo ? t('back') : t('chats')}
                    >
                      {returnTo ? '←' : '☰'}
                    </button>
                    {(() => {
                      const chatOtherUser = enrichChatUserForProfile(
                        selectedChat?.users?.find((u) => u._id !== userId)
                      );
                      const profileClickable = canOpenProviderProfile(chatOtherUser);
                      const displayName = chatOtherUser?.fullName || 'Usuario';
                      const avatar = (
                        <img
                          src={chatOtherUser?.avatar || '/images/resource/user-placeholder.png'}
                          alt={displayName}
                          className="w-10 h-10 rounded-full object-cover shrink-0"
                        />
                      );
                      return profileClickable ? (
                        <button
                          type="button"
                          onClick={() => handleOpenProviderProfile(chatOtherUser)}
                          className="flex items-center gap-3 min-w-0 text-left hover:opacity-80"
                          title={displayName}
                        >
                          {avatar}
                          <div className="font-semibold text-lg truncate max-w-[60vw] sm:max-w-[320px] hover:underline">
                            {displayName}
                          </div>
                        </button>
                      ) : (
                        <>
                          {avatar}
                          <div className="flex-1 min-w-0">
                            <div
                              className="font-semibold text-lg truncate max-w-[60vw] sm:max-w-[320px]"
                              title={displayName}
                            >
                              {displayName}
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    { user?.type === 'worker' && (
                      <button
                        className="lg:hidden p-2 rounded-full hover:bg-gray-100"
                        onClick={() => { setProposalPopupMode('direct'); handleProposalPopup(selectedChat) }}
                        aria-label={t('sendProposal')}
                        title={t('sendProposal')}
                      >
                        💼
                      </button>
                    )}
                    { user?.type === 'worker' && (
                      <CustomButton
                        handleButtonClick={()=> { setProposalPopupMode('direct'); handleProposalPopup(selectedChat) }}
                        label={t('sendProposal')}
                        labelStyle="text-white"
                        className="hidden lg:inline-flex bg-blue-500 px-6 py-2 rounded-3xl"
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* Messages */}
              <div ref={messagesScrollRef} className="flex-1 overflow-y-auto overflow-x-hidden min-h-0 px-4 lg:px-8 py-6 flex flex-col gap-3 bg-[#F7F9FB]" style={{ WebkitOverflowScrolling: 'touch' }}>
                {messages.map((msg, index) => {
                  const messageOwner = msg.owner ?? msg.sender;
                  let legacyImageUrls: string[] = [];
                  let isLegacyImageOnly = false;

                  try {
                    const parsed = JSON.parse(msg.message);
                    if (Array.isArray(parsed) && parsed.every(url => typeof url === 'string' && url.includes('http'))) {
                      legacyImageUrls = parsed;
                      isLegacyImageOnly = true;
                    }
                  } catch (e) {
                    // Not legacy JSON image message
                  }

                  const hasBackendImages = Array.isArray(msg.imageUrls) && msg.imageUrls.length > 0;
                  const attachmentUrls = hasBackendImages
                    ? msg.imageUrls
                    : isLegacyImageOnly
                      ? legacyImageUrls
                      : [];
                  const showText = !isLegacyImageOnly || hasBackendImages;

                  const isQuoteRequest =
                    typeof msg.message === 'string' &&
                    msg.message.trim().includes('New Quote Request');
                  const jobUid = typeof msg.message === 'string'
                    ? extractJobUid(msg.message)
                    : null;

                  return (
                    <div
                      key={index}
                      className={`flex ${messageOwner === userId ? 'justify-end' : 'justify-start'}`}
                    >
                      <div
                        className={`relative rounded-lg px-4 py-2 text-sm max-w-[60%] overflow-visible ${
                          messageOwner === userId
                            ? 'bg-blue-500 text-white sm:ml-8 ml-2'
                            : 'bg-white text-gray-800 sm:mr-8 mr-2'
                        }`}
                      >
                        {isQuoteRequest && jobUid && msg?.isQuote && user?.type === 'worker' && (
                          <button
                            onClick={() => handleQuoteAction(selectedChat, jobUid)}
                            className="absolute top-1 right-1 z-10 text-xs px-2 py-1 rounded bg-blue-500 text-white hover:bg-gray-300"
                          >
                            View
                          </button>
                        )}

                        {showText && msg.message?.trim() && (
                          <div className="whitespace-pre-wrap break-words break-all">
                            {msg.message}
                          </div>
                        )}

                        {attachmentUrls.length > 0 && (
                          <div className={`flex flex-wrap gap-2 ${showText && msg.message?.trim() ? 'mt-2' : ''}`}>
                            {attachmentUrls.map((imageUrl, imgIndex) => (
                              <div
                                key={imgIndex}
                                className="cursor-pointer"
                                onClick={() => setPreviewImage(imageUrl)}
                              >
                                <LazyImage
                                  src={imageUrl}
                                  alt={`Image ${imgIndex + 1}`}
                                  className="h-16 w-16 rounded border object-cover"
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
                <div ref={messagesEndRef} />
              </div>

              {/* Input */}
              <div className="sticky bottom-0 z-10 px-4 lg:px-8 py-4 border-t border-gray-200 bg-white pb-[env(safe-area-inset-bottom)] mb-2 flex-shrink-0" style={{ WebkitTransform: 'translateZ(0)', willChange: 'transform' }}>
                {/* Image Previews */}
                {imagePreviews.length > 0 && (
                  <div className="flex flex-wrap gap-2 mb-3">
                    {imagePreviews.map((preview, idx) => (
                      <div key={idx} className="relative">
                        <img src={preview} alt={`Selected ${idx + 1}`} className="h-16 w-20 rounded-md border border-gray-300 object-cover" />
                        <button
                          type="button"
                          className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 bg-red-500 text-white rounded-full text-xs font-bold"
                          onClick={() => handleRemoveImage(idx)}
                          aria-label="Eliminar imagen"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                
                <div className="flex items-end gap-3">
                  <button 
                    type="button"
                    onClick={handleImageButtonClick}
                    className="text-blue-500 text-2xl w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors shrink-0"
                  >
                    📷
                  </button>
                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleFileInputChange}
                    className="hidden"
                  />
                  {/* Only show input field if no images are selected */}
                    <textarea
                      ref={messageInputRef}
                      rows={1}
                      placeholder="Aa"
                      disabled={selectedImages.length > 0}
                      className="flex-1 px-4 py-2 rounded-3xl bg-gray-100 focus:outline-none text-base resize-none overflow-y-auto max-h-32 leading-5"
                      value={input}
                      onChange={handleMessageInputChange}
                      onKeyDown={handleMessageInputKeyDown}
                    />
                  
                  <CustomButton
                    handleButtonClick={sendMessage}
                    disabled={isUploadingImages}
                    isLoading={isUploadingImages}
                    
                    icon={!isUploadingImages ? <SendIcon /> : <></>}
                    iconAfter={false}
                    iconStyle='!ml-0'
                    label=''
                    // label={isUploadingImages ? 'Uploading...' : 'Send'}
                    labelStyle="text-white"
                    className="bg-blue-500 text-white rounded-full min-w-0 w-10 px-0 mx-0 h-10 flex items-center justify-center text-xl disabled:opacity-50 shrink-0"
                  />
                   
                </div>
              </div>
            </>
          ) : otherUser ? (
            // Show other user details and message input when no existing chat
            <>
              {/* Header with other user details */}
              <div className="sticky top-0 z-20 bg-white border-b border-gray-200 flex-shrink-0" style={{ WebkitTransform: 'translateZ(0)', willChange: 'transform' }}>
                <div className="flex items-center justify-between px-4 lg:px-8 h-14 lg:h-16">
                  <div className="flex items-center gap-3 min-w-0">
                    <button
                      className="lg:hidden p-2 hover:bg-gray-100 rounded-full shrink-0"
                      onClick={handleMobileChatBack}
                      aria-label={returnTo ? t('back') : t('chats')}
                    >
                      {returnTo ? '←' : '☰'}
                    </button>
                    {isLoadingOtherUser ? (
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
                        <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
                      </div>
                    ) : canOpenProviderProfile(otherUser) ? (
                      <button
                        type="button"
                        onClick={() => handleOpenProviderProfile(otherUser)}
                        className="flex items-center gap-3 min-w-0 text-left hover:opacity-80"
                        title={otherUser?.fullName || 'Usuario'}
                      >
                        <img
                          src={otherUser?.avatar || '/images/resource/user-placeholder.png'}
                          alt={otherUser?.fullName || 'Usuario'}
                          className="w-10 h-10 rounded-full object-cover shrink-0"
                        />
                        <div className="flex-1 min-w-0">
                          <div className="font-semibold text-lg truncate max-w-[60vw] sm:max-w-[320px] hover:underline">
                            {otherUser?.fullName || 'Usuario'}
                          </div>
                          <div className="text-xs text-gray-400">{t('startAConversation')}</div>
                        </div>
                      </button>
                    ) : (
                      <>
                        <img
                          src={otherUser?.avatar || '/images/resource/user-placeholder.png'}
                          className="w-10 h-10 rounded-full object-cover shrink-0"
                        />
                        <div className="flex-1 min-w-0">
                          <div className="font-semibold text-lg truncate max-w-[60vw] sm:max-w-[320px]" title={otherUser?.fullName || 'Usuario'}>
                            {otherUser?.fullName || 'Usuario'}
                          </div>
                          <div className="text-xs text-gray-400">{t('startAConversation')}</div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Empty messages area */}
              <div ref={messagesScrollRef} className="flex-1 overflow-y-auto overflow-x-hidden min-h-0 px-4 lg:px-8 py-6 flex flex-col gap-3 bg-[#F7F9FB]" style={{ WebkitOverflowScrolling: 'touch' }}>
                <div className="flex-1 flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-6xl mb-4">💬</div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">{t('startAConversation')}</h2>
                    <p className="text-gray-600 text-sm">
                      {t('sendMessageToUser')} {otherUser?.fullName || 'este usuario'} {t('startChating')}.
                    </p>
                  </div>
                </div>
              </div>

              {/* Message input for new conversation */}
              <div className="sticky bottom-0 bg-white pb-[env(safe-area-inset-bottom)] z-10">

                <div className="flex items-end gap-3">
                  <button 
                    type="button"
                    onClick={handleImageButtonClick}
                    className="text-blue-500 text-2xl w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors shrink-0"
                  >
                    📷
                  </button>
                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleFileInputChange}
                    className="hidden"
                  />
                  <textarea
                    ref={messageInputRef}
                    rows={1}
                    placeholder="Escribe un mensaje..."
                    disabled={selectedImages.length > 0}
                    className="flex-1 px-4 py-2 rounded-3xl bg-gray-100 focus:outline-none text-base resize-none overflow-y-auto max-h-32 leading-5"
                    value={input}
                    onChange={handleMessageInputChange}
                    onKeyDown={handleMessageInputKeyDown}
                  />
                  
                  <CustomButton
                    handleButtonClick={sendMessage}
                    disabled={isUploadingImages}
                    isLoading={isUploadingImages}
                    icon={!isUploadingImages ? <SendIcon /> : <></>}
                    iconAfter={false}
                    iconStyle='!ml-0'
                    label=''
                    labelStyle="text-white"
                    className="bg-blue-500 text-white rounded-full min-w-0 w-10 px-0 mx-0 h-10 flex items-center justify-center text-xl disabled:opacity-50 shrink-0"
                  />
                </div>
              </div>
            </>
          ) : isLoadingChatList ? (
            // Loading state while fetching chats
            <>
              <div className="sticky top-0 z-20 bg-white border-b border-gray-200 flex-shrink-0" style={{ WebkitTransform: 'translateZ(0)', willChange: 'transform' }}>
                <div className="flex items-center justify-between px-4 lg:px-8 h-14 lg:h-16">
                  <div className="flex items-center gap-3 min-w-0">
                    <button
                      className="lg:hidden p-2 hover:bg-gray-100 rounded-full shrink-0"
                      onClick={handleMobileChatBack}
                      aria-label={returnTo ? t('back') : t('chats')}
                    >
                      {returnTo ? '←' : '☰'}
                    </button>
                    <h2 className="text-lg font-semibold">{t('chats')}</h2>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex flex-col items-center justify-center bg-[#F7F9FB] px-4 lg:px-8">
                <CircularProgress size={50} />
              </div>
            </>
          ) : chatList.length === 0 ? (
            // Empty state when no chats exist (only show after loading completes)
            <>
              <div className="sticky top-0 z-20 bg-white border-b border-gray-200 flex-shrink-0" style={{ WebkitTransform: 'translateZ(0)', willChange: 'transform' }}>
                <div className="flex items-center justify-between px-4 lg:px-8 h-14 lg:h-16">
                  <div className="flex items-center gap-3 min-w-0">
                    <button
                      className="lg:hidden p-2 hover:bg-gray-100 rounded-full shrink-0"
                      onClick={handleMobileChatBack}
                      aria-label={returnTo ? t('back') : t('chats')}
                    >
                      {returnTo ? '←' : '☰'}
                    </button>
                    <h2 className="text-lg font-semibold">{t('chats')}</h2>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex flex-col items-center justify-center bg-[#F7F9FB] px-4 lg:px-8">
                <div className="text-center max-w-md">
                  <div className="text-6xl mb-4">💬</div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-2">{t('noMessagesYet')}</h2>
                  <p className="text-gray-600 text-base leading-relaxed">
                    {t('startConversation')}
                  </p>
                </div>
              </div>
            </>
          ) : (
            // Loading state or default state when chats exist but none selected
            <>
              <div className="sticky top-0 z-20 bg-white flex items-center justify-between px-4 lg:px-8 py-4 border-b border-gray-200 flex-shrink-0" style={{ WebkitTransform: 'translateZ(0)', willChange: 'transform' }}>
                <div className="flex items-center gap-3">
                  <button
                    className="lg:hidden p-2 hover:bg-gray-100 rounded-full"
                    onClick={handleMobileChatBack}
                    aria-label={returnTo ? t('back') : t('chats')}
                  >
                    {returnTo ? '←' : '☰'}
                  </button>
                  <h2 className="text-lg font-semibold">{t('chats')}</h2>
                </div>
              </div>
              <div className="flex-1 flex items-center justify-center bg-[#F7F9FB]">
                <div className="text-center">
                  <p className="text-gray-500 text-lg">{t('selectTheChat')}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </ChatContainer>
  );
};

export default ChatUI;
